// @flow

import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import { STATUS_SUCCESS } from 'constants/statusConstants';

import { generateID } from 'utils/idGeneratorUtils';

import Loading from 'components/fragments/Loading';
import BackgroundImage from 'components/fragments/BackgroundImage';
import Breadcrumb from 'components/fragments/Breadcrumb';
import Sidebar from 'components/sidebar/Sidebar';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';

import type { Status } from 'types/Status';
import type { BlocContent } from 'types/NewsletterBloc';
import type { AlbumType } from 'types/Albums';
import type { RouterProps } from 'types/Router';

export type StateProps = {
  album: AlbumType,
  albumStatus: Status,
  sidebar: BlocContent[],
  slug_parent: string,
  titleParent: string
};

export type DispatchProps = {
  fetchAlbum: (slug: string, args: string) => void,
  fetchPageNode: (slug: string) => void,
  resetPageNode: () => void
};

type Props = StateProps & DispatchProps & RouterProps;

export default class PageMediaDetail extends PureComponent<Props> {
  componentDidMount() {
    const {
      match: {
        params: { slug }
      },
      location: { pathname },
      fetchAlbum,
      fetchPageNode
    } = this.props;

    if (pathname && pathname.includes('--album')) {
      const splitedPathname = pathname.split('/')
      const album = splitedPathname && splitedPathname[splitedPathname.length - 1].replace('--album', '') || '';
      const node = splitedPathname && splitedPathname[splitedPathname.length - 2] || '';
      if (!!node) {
        fetchPageNode(node);
      }
      if (!!album) {
        fetchAlbum(album, '');
      }
    } else if (slug && slug.includes('--album')) {
      fetchAlbum(slug.replace('--album', ''), '');
    }
  }

  renderAlbumMosaic = () => {
    const {
      album: {
        content: { data }
      }
    } = this.props;

    return data.map<any>(blocFigure => {
      if (blocFigure.tagName === 'figure') {
        return <ContentBloc key={generateID()} {...blocFigure} />;
      }
      return null;
    });
  };

  renderExcerpt = () => {
    const {
      album: {
        content: { data }
      }
    } = this.props;

    return data.map<any>(blocFigure => {
      if (blocFigure.tagName !== 'figure') {
        return <ContentBloc key={generateID()} {...blocFigure} />;
      }
      return null;
    });
  };

  render() {
    const {
      album: { excerpt, meta_title, featured_media, breadcrumb, parent_link },
      albumStatus,
      sidebar
    } = this.props;

    const headerFilterClasses =
      'header-filter header-filter--team header-filter--teamWfilter ' +
      'header-filter--specific header-filter--specific--Wfilter mt-2';

    if (albumStatus !== STATUS_SUCCESS) {
      return <Loading />;
    }

    let bannerClass = 'banner';

    return (
      <>
        <section className={bannerClass}>
          <BackgroundImage
            className="banner__thumbnail img-blue-dark"
            illustration={featured_media.src}
            baliseImg={false}
          />
          <div className="container">
            {breadcrumb && <Breadcrumb elements={breadcrumb} isDark />}
            <h1 className="ft-h2">{meta_title}</h1>
            {excerpt.raw && <p className="banner__desc">{excerpt.raw}</p>}
          </div>
        </section>
        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-9 bg-overflow">
              <section>
                <div className={headerFilterClasses}>
                  <div className="row">
                    <div className="col">
                      <div className="header-filter__left">
                        <Link to={parent_link} className="link-chevron link-chevron--left">
                          <span>Retour aux albums</span>
                          <i className="icon icon-chevron-left" />
                        </Link>
                      </div>
                      <div className="header-filter__right">{/* @TODO : do right filters */}</div>
                    </div>
                  </div>
                </div>
                <div className="header-filter__sep mb-5" />
                <div className="row">
                  <div className="col col-lg-8on9">
                    {this.renderExcerpt()}
                    {this.renderAlbumMosaic()}
                  </div>
                </div>
              </section>
            </div>
            <Sidebar sidebarContent={sidebar} />
          </div>
        </div>
      </>
    );
  }
}
